import { classMetadataKey } from './common';
import { getMetadata, defineMetadata } from 'reflect-metadata/no-conflict';
export function ApiConfig(config) {
    return function (target, key = classMetadataKey) {
        const metadata = getMetadata('api-config', target, key);
        const nextMetadata = metadata ? [...metadata, config] : [config];
        defineMetadata('api-config', nextMetadata, target, key);
    };
}
//# sourceMappingURL=decorators.js.map